<app-loading *ngIf="contentReady"></app-loading>
<div class="container mb-4">
  <div class="row d-flex justify-content-center align-items-center">
    <div class="col-lg-5 col-md-8 col-sm-12" *ngIf='loggedIn'>
      <h1 class="logintext">{{ "logged in" | translate }}</h1>
    </div>
    <div class="col-lg-5 col-md-8 col-sm-12" *ngIf='!loggedIn'>
      <h1 class="logintext">{{ "Log in" | translate }}</h1>
      <form class="form" [formGroup]="person" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label class="label" for="username">{{ "username" | translate }}</label>
          <input class="input" type="text" id="username" formControlName="username"
            placeholder="{{ 'username' | translate }}" />
        </div>
        <div class="form-group">
          <label class="label" for="Password">{{
            "Password" | translate
            }}</label>
          <input class="input" id="Password" type="{{ isPasswordVisible ? 'text' : 'password' }}"
            formControlName="password" placeholder="{{ 'Password' | translate }}" />
          <button type="button" class="hidePasswordBtn" (click)="togglePasswordVisibility()">
            @if(!isPasswordVisible){
            {{ "Show Password" | translate }}
            } @else {
            {{ "Hide Password" | translate }}
            }
          </button>
        </div>

        <h6 class="passtext"> {{ "welcomeinblue" | translate }}</h6>

        <hr class="line" width="100%" size="3" noshade />
        <button type="submit" class="submit-btn login">
          {{ "Log in" | translate }}
        </button>

      </form>
    </div>
  </div>
</div>